import React, { useState, useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import { Select } from "components/common";
import NumberUtils from "util/NumberUtils";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const StyledForm = styled.form`
  margin-top: 10px;
  margin-bottom: 15px;

  .form-group {
    width: 400px;
  }
`;
const StyledP = styled.p`
  margin-top: 5px;
`;
const _getDefaultIndex = (indices) => {
  const defaultIndex = indices.filter(
    (index) => !index.index_name.endsWith("restored_archive") && index.document_count >= 1
  )[0];
  return defaultIndex == null ? void 0 : defaultIndex.index_name;
};
const ArchiveCreationForm = ({ indices: indicesProp, createArchive = () => {
} }) => {
  const { t } = useTranslation("enterprise_archive");
  const indices = indicesProp || [];
  const storableIndices = indices.filter(({ index_name }) => !index_name.endsWith("restored_archive"));
  const [selectedIndexName, setSelectedIndexName] = useState(_getDefaultIndex(indices));
  const indicesOptions = useMemo(() => {
    if (storableIndices.length) {
      return storableIndices.map((index) => {
        const docs = index.document_count;
        const size = NumberUtils.formatBytes(index.store_size_bytes);
        return {
          value: index.index_name,
          label: t("archive_creation_form.index_option", {
            index: index.index_name,
            documents: NumberUtils.formatNumber(docs),
            size
          }),
          disabled: docs < 1
        };
      });
    }
    return [{ value: "none", label: t("archive_creation_form.no_indices"), disabled: true }];
  }, [storableIndices, t]);
  const sendTelemetry = useSendTelemetry("archive-catalog");
  const _onIndexSelect = (selection) => {
    if (selection === "") {
      setSelectedIndexName(_getDefaultIndex(indices));
    }
    setSelectedIndexName(selection);
  };
  const _onSubmit = (e) => {
    e.preventDefault();
    if (selectedIndexName) {
      createArchive(selectedIndexName);
    }
    sendTelemetry(TELEMETRY_EVENT_TYPE.ARCHIVE.CREATED, {
      app_pathname: "archive"
    });
  };
  const _isButtonDisabled = () => {
    var _a;
    return !selectedIndexName || ((_a = indices.find(({ index_name }) => index_name === selectedIndexName)) == null ? void 0 : _a.document_count) < 1;
  };
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h2", null, t("archive_creation_form.title")), /* @__PURE__ */ React.createElement(StyledP, null, t("archive_creation_form.description")), /* @__PURE__ */ React.createElement(StyledForm, { className: "form-inline", onSubmit: _onSubmit }, /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement(
    Select,
    {
      "aria-label": t("archive_creation_form.select_aria_label"),
      placeholder: t("archive_creation_form.select_placeholder"),
      options: indicesOptions,
      onChange: _onIndexSelect,
      value: selectedIndexName
    }
  )), "\xA0", /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", type: "submit", disabled: _isButtonDisabled() }, t("archive_creation_form.archive_index"))));
};
export default ArchiveCreationForm;
